export default __webpack_public_path__ + "static/media/upload_docs.9c3cd7ed.svg";